import PageHeader from "@/components/PageHeader";
import Spinner from "@/components/Spinner";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { StructureAssignmentsForm } from "@/modules/structure-assignments/components/StructureAssignmentsForm";
import { useStructureAssignmentsBreadcrumbs } from "@/modules/structure-assignments/hooks/useStructureAssignmentsBreadcrumbs";
import { useStructureAssignmentsParams } from "@/modules/structure-assignments/hooks/useStructureAssignmentsParams";
import { useWriteStructureAssignmentsMutation } from "@/modules/structure-assignments/hooks/useWriteStructureAssignmentsMutation";
import { StructureAssignmentsService } from "@/modules/structure-assignments/services/structureAssignments";
import { writeStructureAssignment } from "@/schemas/structure-assignment";
import { useQuery } from "@tanstack/react-query";
import { memo } from "react";
import { useTranslation } from "react-i18next";

export const StructureAssignmentsEditor = memo(() => {
  const { can_update } = useModulePermissions();
  const { supervisorId, assignmentType } = useStructureAssignmentsParams();
  const { t } = useTranslation();

  const queryFn = () =>
    StructureAssignmentsService.get(supervisorId, assignmentType);

  const assignmentQuery = useQuery({
    queryKey: ["structureAssignment", supervisorId, assignmentType],
    enabled: !!supervisorId && !!assignmentType,
    queryFn,
  });

  const updateMutation = useWriteStructureAssignmentsMutation();
  const breadcrumbItems = useStructureAssignmentsBreadcrumbs([
    {
      label: t("structureAssignments.breadcrumb.edit"),
    },
  ]);

  if (assignmentQuery.isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <StructureAssignmentsForm
        mutation={updateMutation}
        schema={writeStructureAssignment}
        query={assignmentQuery}
        disabled={!can_update}
      />
    </>
  );
});
